import React, { useState } from 'react';
import { Eyebrow, SectionStamp } from '../components/Atoms';
import Icon from '../components/Icon';
import DesktopHeader from '../components/DesktopHeader';
import DesktopFooter from '../components/DesktopFooter';
import DesktopWhatsAppFab from '../components/DesktopWhatsAppFab';
import { fonts } from '../theme';

const ROWS = [
  { ic: 'phone', k: '+91 6353 937 571', v: 'Call · Mon–Sat, 9–7', href: 'tel:+916353937571' },
  { ic: 'mail', k: 'moxapatel1908@gmail.com', v: 'Email · Reply within 24h', href: 'mailto:moxapatel1908@gmail.com' },
  { ic: 'pin', k: 'Vadodara, Gujarat', v: 'Clinic & home visits', href: 'https://maps.google.com/?q=Vadodara,+Gujarat' },
];

export default function ContactDesktop({ t }) {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const update = (k, v) => setForm(p => ({ ...p, [k]: v }));

  return (
    <div style={{
      width: '100%', minHeight: '100vh', background: t.paper, color: t.ink,
      fontFamily: fonts.sans, position: 'relative', overflow: 'hidden',
    }}>
      <DesktopHeader t={t} />

      <div style={{ padding: '80px max(56px, 4vw) 40px', maxWidth: 1440, margin: '0 auto' }}>
        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 56, alignItems: 'end',
        }}>
          <div>
            <SectionStamp n="—" label="Get in touch" t={t}/>
            <h1 style={{
              fontFamily: fonts.serif, fontSize: 'clamp(56px, 7vw, 96px)', fontWeight: 300,
              letterSpacing: '-0.04em', lineHeight: 0.92, margin: '20px 0 0',
              textWrap: 'balance',
            }}>
              Let&rsquo;s <span style={{ fontStyle: 'italic', color: t.mintDeep }}>talk.</span>
            </h1>
          </div>
          <p style={{
            fontFamily: fonts.sans, fontSize: 16, color: t.muted, lineHeight: 1.6,
            margin: 0, maxWidth: 480,
          }}>
            Direct contact below — phone, email, or WhatsApp. Or send a note and I&rsquo;ll come back within a day.
          </p>
        </div>
      </div>

      <div style={{
        padding: '24px max(56px, 4vw) 80px', maxWidth: 1440, margin: '0 auto',
        display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 56, alignItems: 'start',
      }}>
        <div>
          {ROWS.map((row, i) => (
            <a
              key={i}
              href={row.href}
              target={row.href.startsWith('http') ? '_blank' : undefined}
              rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', gap: 20,
                padding: '24px 0', borderBottom: `0.5px solid ${t.hair}`,
                borderTop: i === 0 ? `0.5px solid ${t.hair}` : 'none',
                color: 'inherit', textDecoration: 'none',
              }}
            >
              <div style={{
                width: 48, height: 48, borderRadius: 12, background: t.cream,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: t.ink, flexShrink: 0,
              }}>
                <Icon name={row.ic} size={22} sw={1.6}/>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  fontFamily: fonts.serif, fontSize: 22, fontWeight: 400,
                  letterSpacing: '-0.01em',
                }}>{row.k}</div>
                <div style={{ fontFamily: fonts.sans, fontSize: 13, color: t.muted, marginTop: 4 }}>
                  {row.v}
                </div>
              </div>
              <Icon name="arrow-up-right" size={20} stroke={t.muted}/>
            </a>
          ))}

          <div style={{
            marginTop: 32, borderRadius: 18, padding: 32,
            background: t.ink, color: t.paper, position: 'relative', overflow: 'hidden',
          }}>
            <Eyebrow t={t} color={t.mint}>Home visits · Vadodara</Eyebrow>
            <div style={{
              fontFamily: fonts.serif, fontSize: 'clamp(28px, 3vw, 40px)', lineHeight: 1.05,
              fontWeight: 300, letterSpacing: '-0.02em', marginTop: 16, color: t.paper,
              textWrap: 'balance',
            }}>
              <span>Care that comes to your </span>
              <span style={{ fontStyle: 'italic', color: t.mint }}>doorstep.</span>
            </div>
            <p style={{
              fontFamily: fonts.sans, fontSize: 14, color: 'rgba(246,243,236,0.7)',
              lineHeight: 1.6, marginTop: 14, maxWidth: 380,
            }}>
              Personalised physiotherapy at your home — same care, more comfort.
            </p>
            <Icon name="home" size={180} stroke={t.mint} sw={0.6}
              style={{ position: 'absolute', right: -30, top: -30, opacity: 0.12 }}/>
          </div>
        </div>

        <div style={{
          padding: 40, borderRadius: 18, border: `0.5px solid ${t.hair}`,
          background: 'transparent',
        }}>
          <SectionStamp n="—" label="Send a note" t={t}/>
          {submitted ? (
            <div style={{
              marginTop: 24, padding: 32, borderRadius: 14,
              background: t.mint, color: t.ink,
              display: 'flex', alignItems: 'center', gap: 16,
            }}>
              <Icon name="check" size={24} stroke={t.ink} sw={2}/>
              <div style={{ fontFamily: fonts.serif, fontSize: 20 }}>
                Thank you. I&rsquo;ll be in touch shortly.
              </div>
            </div>
          ) : (
            <form
              style={{ marginTop: 20 }}
              onSubmit={(e) => { e.preventDefault(); setSubmitted(true); }}
            >
              {[
                { k: 'name', label: 'Name', placeholder: 'Your name' },
                { k: 'email', label: 'Email', placeholder: 'someone@example.com', type: 'email' },
              ].map(f => (
                <div key={f.k} style={{ marginBottom: 16 }}>
                  <label style={{
                    fontFamily: fonts.mono, fontSize: 10, color: t.muted,
                    letterSpacing: '0.18em', textTransform: 'uppercase',
                    display: 'block', marginBottom: 8,
                  }}>{f.label}</label>
                  <input
                    type={f.type || 'text'}
                    value={form[f.k]}
                    onChange={(e) => update(f.k, e.target.value)}
                    placeholder={f.placeholder}
                    style={{
                      width: '100%', padding: 16, background: 'transparent', color: t.ink,
                      border: `0.5px solid ${t.hair}`, borderRadius: 12,
                      fontFamily: fonts.sans, fontSize: 15, outline: 'none',
                    }}
                  />
                </div>
              ))}
              <div style={{ marginBottom: 20 }}>
                <label style={{
                  fontFamily: fonts.mono, fontSize: 10, color: t.muted,
                  letterSpacing: '0.18em', textTransform: 'uppercase',
                  display: 'block', marginBottom: 8,
                }}>Message</label>
                <textarea
                  value={form.message}
                  onChange={(e) => update('message', e.target.value)}
                  placeholder="What can I help with?"
                  style={{
                    width: '100%', padding: 14, minHeight: 140, background: 'transparent', color: t.ink,
                    border: `0.5px solid ${t.hair}`, borderRadius: 12,
                    fontFamily: fonts.sans, fontSize: 15, resize: 'none', outline: 'none',
                  }}
                />
              </div>
              <button type="submit" style={{
                appearance: 'none', border: 'none', cursor: 'pointer',
                background: t.ink, color: t.paper, padding: '16px 28px', borderRadius: 999,
                fontFamily: fonts.sans, fontSize: 14, fontWeight: 500,
                display: 'inline-flex', alignItems: 'center', gap: 10,
              }}>
                <span>Send message</span>
                <Icon name="arrow-up-right" size={16}/>
              </button>
            </form>
          )}
        </div>
      </div>

      <DesktopFooter t={t} />
      <DesktopWhatsAppFab />
    </div>
  );
}
